module.exports = __webpack_public_path__ + "img/cert14.cb61f271.jpg";